<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<ul class="vx-timeline">
		<li v-for="item in data" :key="item.title">
			<div class="timeline-icon" :class="`bg-${item.color}`">
				<feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
			</div>
			<div class="timeline-info">
				<p class="font-semibold">{{ item.title }}</p>
				<span class="activity-desc">{{ item.desc }}</span>
			</div>
			<small class="text-grey activity-e-time">{{ item.time }}</small>
		</li>
	</ul>
</template>

<script>
export default {
	name: "vx-timeline",
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
.bg-assigned {
	background-color: #28c76f !important;
}
.bg-rescheduled {
	background-color: #006eff !important;
}
.bg-canceled {
	background-color: #ff0000 !important;
}
.bg-finalized {
	background-color: #19663b !important;
}
.bg-in-progress {
	background-color: #ff9f43 !important;
}
.bg-delayed {
	background-color: #ff7070 !important;
}
.bg-on-the-way {
	background-color: #ffbe81 !important;
}
.bg-no-assigned {
	background-color: #a0a0a0 !important;
}
.bg-ondemand {
	background-color: #886ce4 !important;
}
</style>
